import Image from "next/image";
import { ComponentProps } from "react";

import { CLIENT_LOGO_INFO, EClientKey } from "@/constants/clients";
import { CLIENT_LOGO_IMAGE_PATH } from "@/constants/path";
import { cn } from "@/utils/cn";

interface LogoImageProps extends ComponentProps<"div"> {
  client: EClientKey;
}

function LogoImage({ className, client }: LogoImageProps) {
  const { logoWidth, name } = CLIENT_LOGO_INFO[client];
  return (
    <div
      style={{
        aspectRatio: `${logoWidth} / 52`,
      }}
      className={cn("relative h-8", className)}
    >
      <Image
        src={CLIENT_LOGO_IMAGE_PATH({ client })}
        alt={name}
        fill
        quality={100}
        className="object-contain"
      />
    </div>
  );
}

export default LogoImage;
